export const annualReviewOfDrivingRecordAndDriversCertification = (
   name?: string,
   ssn?: string,
   date?: string,
   representative?: string,
   title?: string,
): any => {
  return [
    { text: "Annual Review of Driving Record & Driver's Certification", style: 'h1' },
    { canvas: [
        // Date of Birth
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 200,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        // SSN
        {
          type: 'line',
          x1: 500,
          y1: 0,
          x2: 350,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
      margin: [0, 30, 0, 0],
    },

    { text: `${name}`, margin: [0, -16, 0, 0] },
    { text: "Print Name", style: 'label', margin: [0, 4, 0, 0] },
    { text: `${ssn}`, margin: [350, -30, 0, 0] },
    { text: "Social Security Number", style: 'label', margin: [350, 4, 0, 0] },

    {
      text: 'Part 391.25 requires the motor carrier to make an inquiry into the driving record of each driver it Employs at least once every 12 months. In addition, Part 391.27 requires each driver to prepare a list, at least once every 12 months, of all violations of motor vehicle traffic laws and ordinances (other than parking violations).',
      style: 'p',
      margin: [0, 20, 0, 10]
    },

    { text: 'To be completed by driver', bold: true, alignment: 'center', margin: [0, 0, 0, 10] },

    {
      text: 'I certify that the following is a true and complete list of traffic violations (other than violations) for which I have been convicted of or forfeited bond or collateral during the past 12 months.',
      style: 'p',
    },

    {
      columns: [
        {
          width: 75,
          text: 'Date',
          bold: true,
          fontSize: 11,
        },
        {
          width: '*',
          text: 'Offense',
          bold: true,
          fontSize: 11,
        },
        {
          width: 75,
          text: 'Location',
          bold: true,
          fontSize: 11,
          margin: [15, 0, 0, 0],
        },
        {
          width: 150,
          text: 'Type of Vehicle',
          bold: true,
          fontSize: 11,
          margin: [10, 0, 0, 0],
        }
      ],
      columnGap: 10
    },
    {
      columns: [
        { width: 75, canvas: [{ type: 'line', x1: 0, y1: 0, x2: 75, y2: 0, lineWidth: 1, lineColor: 'black' }] },
        { width: '*', canvas: [{ type: 'line', x1: 0, y1: 0, x2: 200, y2: 0, lineWidth: 1, lineColor: 'black' }] },
        { width: 75, canvas: [{ type: 'line', x1: 0, y1: 0, x2: 75, y2: 0, lineWidth: 1, lineColor: 'black' }] },
        { width: 150, canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 1, lineColor: 'black' }] },
      ],
      columnGap: 10,
      margin: [0, 20, 0, 0],
    },
    {
      columns: [
        { width: 75, canvas: [{ type: 'line', x1: 0, y1: 0, x2: 75, y2: 0, lineWidth: 1, lineColor: 'black' }] },
        { width: '*', canvas: [{ type: 'line', x1: 0, y1: 0, x2: 200, y2: 0, lineWidth: 1, lineColor: 'black' }] },
        { width: 75, canvas: [{ type: 'line', x1: 0, y1: 0, x2: 75, y2: 0, lineWidth: 1, lineColor: 'black' }] },
        { width: 150, canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 1, lineColor: 'black' }] },
      ],
      columnGap: 10,
      margin: [0, 20, 0, 0],
    },
    {
      columns: [
        { width: 75, canvas: [{ type: 'line', x1: 0, y1: 0, x2: 75, y2: 0, lineWidth: 1, lineColor: 'black' }] },
        { width: '*', canvas: [{ type: 'line', x1: 0, y1: 0, x2: 200, y2: 0, lineWidth: 1, lineColor: 'black' }] },
        { width: 75, canvas: [{ type: 'line', x1: 0, y1: 0, x2: 75, y2: 0, lineWidth: 1, lineColor: 'black' }] },
        { width: 150, canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 1, lineColor: 'black' }] },
      ],
      columnGap: 10,
      margin: [0, 20, 0, 0],
    },
    {
      text: 'If no violations are listed above, I certify that I have not been convicted or forfeited bond or collateral on account of any violation required to be listed during the past 12 months.',
      style: 'p',
      margin: [0, 15, 0, 15],
    },

    {
      canvas: [
        // Signature line
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 200,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        // Date line
        {
          type: 'line',
          x1: 500,
          y1: 0,
          x2: 350,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
    },
    { text: "Driver's Signature", style: 'label', margin: [0, -2, 0, 0] },
    { text: `${date}`, margin: [350, -32, 0, 0] },
    { text: "Date", style: 'label', margin: [350, 5, 0, 0] },

    { text: 'To be completed by the motor carrier', bold: true, alignment: 'center', margin: [0, 20, 0, 10] },

    {
      text: "3391.25(b)(2) The motor carrier must consider the driver’s accident record and any evidence that the driver has violated laws governing the operation of motor vehicles, and must give great weight to violations, such as speeding, reckless driving, and operating while under the influence of alcohol or drugs, that indicate that the driver has exhibited a disregard for the safety of the public. Recordkeeping. A copy of the driver’s certification and the supervisor’s review must be maintained in the driver’s qualification file for a period of 3 years following the date of completion.",
      fontSize: 8,
      alignment: 'justify',
      margin: [0, 0, 0, 10],
    },

    {
      text: 'A careful review of the driver’s record has been made in accordance with Part 391.25 and he/she has been found to:',
      style: 'p',
    },

    {
      columns: [
        {
          width: 'auto',
          canvas: [
            {
              type: 'rect',
              x: 0,
              y: 0,
              w: 10,
              h: 10,
              lineWidth: 1,
              lineColor: 'black',
            },
            {
              type: 'line',
              x1: 1,
              y1: 5,
              x2: 4,
              y2: 8,
              lineWidth: 1,
              lineColor: 'black',
            },
            {
              type: 'line',
              x1: 4,
              y1: 8,
              x2: 9,
              y2: 2,
              lineWidth: 1,
              lineColor: 'black',
            },
          ],
        },
        {
          text: 'Meet the minimum requirements for safe driving',
          margin: [5, 0, 0, 0],
          fontSize: 10,
        },
      ],
      margin: [0, 10, 0, 0],
    },

    {
      columns: [
        {
          width: 'auto',
          canvas: [
            {
              type: 'rect',
              x: 0,
              y: 0,
              w: 10,
              h: 10,
              lineWidth: 1,
              lineColor: 'black',
            },
          ],
        },
        {
          text: 'Be disqualified to drive a commercial motor vehicle pursuant to Part 391.15.',
          margin: [5, 0, 0, 0],
          fontSize: 10,
        },
      ],
      margin: [0, 10, 0, 30],
    },

    {
      canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 150,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 170,
          y1: 0,
          x2: 320,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 340,
          y1: 0,
          x2: 490,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
      border: [true, false, true, false],
    },
    { text: `${representative}`, margin: [0,-22, 0, 0], border: [true, false, true, false] },
    { text: "Sierra Representative", style: 'label', margin: [0,4,0,0], border: [true, false, true, false] },
    { text: `${title}`, margin: [170,-30, 0, 0], border: [true, false, true, false] },
    { text: "Title", style: 'label', margin: [170,4,0,0], border: [true, false, true, false] },
    { text: `${date}`, margin: [340,-30, 0, 0], border: [true, false, true, false] },
    { text: "Date", style: 'label', margin: [340,4,0,0], border: [true, false, true, true] },

    { text: '', pageBreak: 'before' },
  ];
};